import type { LucideIcon } from 'lucide-react';

/** 16 — инлайн/таблица, 18 — навигация/кнопки, 20 — действия верхней полосы. */
export type IconSize = 16 | 18 | 20;

export interface IconProps {
  icon: LucideIcon;
  size?: IconSize;
  className?: string;
  /**
   * Доступное имя. По умолчанию иконка декоративна: смысл несёт подпись рядом,
   * иконка её только повторяет.
   */
  title?: string;
}

/**
 * Единственный примитив иконки. Все иконки — Lucide, stroke 1.75, currentColor.
 * Иконка никогда не заменяет текст действия и не несёт статус одним цветом.
 */
export function Icon({ icon: Glyph, size = 18, className, title }: IconProps) {
  return (
    <Glyph
      size={size}
      strokeWidth={1.75}
      className={className}
      focusable="false"
      aria-hidden={title ? undefined : true}
      aria-label={title}
      role={title ? 'img' : undefined}
    />
  );
}
